<ion-header>
  <ion-toolbar mode="ios">
    <ion-title slot="start" class="page-title">{{ (terms$ | async)?.header }}</ion-title>

    @if (!partnerEmail) {
      <ion-button
        fill="outline"
        size="small"
        color="gray"
        slot="end"
        class="consent__languageSelect"
        (click)="selectLanguageModal()"
      >
        <ion-label>{{ selectedLanguage }}</ion-label>
        <ion-icon slot="end" [src]="ICON.ARROW_DOWN" color="gray" size="small" />
      </ion-button>
    }
  </ion-toolbar>
</ion-header>

<ion-content uid="beforeYouStart__terms__modal" class="auth__terms" fullscreen>
  <div class="ion-padding">
    @if (terms$ | async; as terms) {
      <ion-list lines="none" class="auth__terms__list">
        <div class="authTerms__span authTerms__legalLink ion-text-wrap">
          <p class="consent__description">{{ terms.description }}</p>
          @for (item of terms.items; track item; let i = $index) {
            <div class="consentTermsItem">
              <ion-item [attr.uid]="'info__ion__item' + i">
                <div class="consentTermsItem authTerms__span ion-text-wrap" uid="info-item">
                  @if (!item.info && !item.toggleInfo) {
                    <ion-label class="consentTermsItem--dot authTerms__span ion-text-wrap" />
                  }
                  @if (!!item.toggleInfo) {
                    <ion-checkbox
                      [attr.uid]="'terms-checkbox' + i"
                      ghost
                      [checked]="toggleMap[item.toggleInfo.key]"
                      (ionChange)="clickItemToggle(item.toggleInfo.key)"
                      color="primary"
                    />
                  }
                  @if (!!item.info) {
                    <app-info-button
                      uid="app-info-button"
                      class="consentTermsItem"
                      slot="start"
                      [html]="item.info | md"
                    />
                  }
                </div>
                <div
                  class="consentTermsItem--text"
                  uid="consent-term-text"
                  [innerHTML]="item.text"
                ></div>
              </ion-item>
            </div>
          }
        </div>
      </ion-list>
    }
  </div>
</ion-content>

<app-scroll-footer [content]="content" color="primary">
  @if (terms$ | async; as terms) {
    <ion-grid class="ion-no-padding">
      <ion-row>
        <ion-col size="12">
          <ion-button
            uid="auth__terms__accept__button"
            class="ion-no-margin"
            shape="round"
            expand="block"
            (click)="accept()"
          >
            <ion-label>{{ terms.acceptButtonLabel }}</ion-label>
          </ion-button>
        </ion-col>
        <ion-col sizeXs="12">
          <ion-button
            uid="auth__terms__decline__button"
            class="ion-no-margin"
            shape="round"
            expand="block"
            fill="outline"
            color="text"
            (click)="decline()"
          >
            <ion-label>{{ terms.declineButtonLabel }}</ion-label>
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  }
</app-scroll-footer>
